import React, { useState } from 'react';
import { X, Mail } from 'lucide-react';
// Mismo formato que el modal de direccion de envio: se reutilizan sus clases
// `sm-*` en vez de copiar la hoja entera (el CSS de este proyecto es global).
import '../ShippingModal/ShippingModal.css';
import './EmailPromptModal.css';

interface EmailPromptModalProps {
  /** Titulo del modal: "Enviar Factura por Email", "Enviar Resguardo por Email"... */
  title: string;
  /** A quien se le manda, para la cabecera. */
  clientName: string;
  /**
   * Email que tiene el cliente en su ficha, '' si no tiene. Decide el aviso del
   * pie y sirve de valor de partida.
   */
  fichaEmail?: string;
  /** Direccion ya elegida, si se esta cambiando una anterior. */
  initialEmail?: string | null;
  /** Texto del boton de confirmar. */
  confirmLabel: string;
  /** Que se hace con la direccion: usar al cobrar, mandar ahora... */
  hint: string;
  onClose: () => void;
  /**
   * Si se pasa, sustituye al boton CANCELAR por una salida que sigue adelante
   * sin direccion ("COBRAR SIN ENVIAR"); la X sigue siendo la que cancela.
   */
  skipLabel?: string;
  onSkip?: () => void;
  onConfirm: (email: string) => void;
}

/** Lo justo para cazar un dedazo. Quien valida de verdad es el servidor de correo. */
const LOOKS_LIKE_EMAIL = /^\S+@\S+\.\S+$/;

/**
 * Pide una direccion de correo para un documento del cliente (factura,
 * resguardo de pedido...).
 *
 * Lo que se teclea aqui NO se guarda en la ficha del cliente: no hay endpoint
 * para actualizar un cliente (ClientService solo lista y crea).
 */
export function EmailPromptModal({
  title,
  clientName,
  fichaEmail,
  initialEmail,
  confirmLabel,
  hint,
  onClose,
  skipLabel,
  onSkip,
  onConfirm
}: EmailPromptModalProps) {
  const [email, setEmail] = useState(initialEmail || fichaEmail || '');

  const value = email.trim();
  const isValid = LOOKS_LIKE_EMAIL.test(value);

  return (
    <div className="sm-overlay epm-overlay">
      <div className="sm-modal">
        <div className="sm-header">
          <div>
            <h3 className="sm-title">{title}</h3>
            <p className="sm-subtitle">Cliente: {clientName}</p>
          </div>
          <button onClick={onClose} className="sm-close" title="Cerrar">
            <X style={{ width: '1.5rem', height: '1.5rem' }} />
          </button>
        </div>

        <div className="sm-form">
          <div className="sm-fields">
            <div className="sm-field">
              <label className="sm-label">Correo electrónico</label>
              <input
                autoFocus
                type="email"
                className="sm-input"
                placeholder="Ej: administracion@empresa.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(e) => { if (e.key === 'Enter' && isValid) onConfirm(value); }}
              />
            </div>
          </div>

          <p className="iem-hint">
            <Mail className="iem-hint-icon" />
            {fichaEmail
              ? hint
              : `Este cliente no tiene email en su ficha. ${hint}`}
          </p>

          <div className="sm-actions">
            {onSkip
              ? <button onClick={onSkip} className="sm-btn-back">{skipLabel || 'OMITIR'}</button>
              : <button onClick={onClose} className="sm-btn-back">CANCELAR</button>}
            <button
              disabled={!isValid}
              onClick={() => onConfirm(value)}
              className="sm-btn-confirm"
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
